import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section id="problem" className="py-16 md:py-24 bg-[#f9f7f2]" data-id="element-254">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-255">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-256">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 text-red-600 mb-6" data-id="element-257">
            <AlertTriangle className="w-8 h-8" data-id="element-258" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2E1B] mb-6" data-id="element-259">
            THE PROBLEM NO ONE WANTS TO ADMIT
          </h2>
          <div className="w-24 h-1 bg-[#C5A55A] mx-auto rounded-full" data-id="element-260"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-261">
          <p className="font-semibold text-xl text-[#2D5A27]" data-id="element-262">
            Dear homeowner in Katy, Cypress, Rosenberg, Richmond, Fulshear, or
            Sealy...
          </p>

          <p data-id="element-263">
            When was the last time you pulled into your driveway and felt proud
            of what you saw?
          </p>

          <p data-id="element-264">Not the interior. Not the car in the driveway.</p>

          <p className="font-bold text-2xl text-[#1B2E1B]" data-id="element-265">The lawn.</p>

          <p data-id="element-266">
            That first square foot of grass that tells the entire world who you
            are, how you live, and how much you care about your property.
          </p>

          <p data-id="element-267">Because let's be honest...</p>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 my-8 relative overflow-hidden" data-id="element-268">
            <div className="absolute left-0 top-0 bottom-0 w-2 bg-[#2D5A27]" data-id="element-269"></div>
            <p className="mb-4" data-id="element-270">You have a beautiful home inside.</p>
            <p className="mb-4" data-id="element-271">
              You decorated it with care. You keep it clean. It took you years
              of hard work to pay for it.
            </p>
            <p className="mb-4 font-semibold text-[#1B2E1B]" data-id="element-272">
              But outside... the grass is growing wild.
            </p>
            <p className="mb-4" data-id="element-273">
              The edges are uneven. There are yellow patches that won't go away.
              The weeds are winning the battle.
            </p>
            <p className="italic text-gray-500 border-l-4 border-[#C5A55A] pl-4 py-2 my-6" data-id="element-274">
              "I need to fix that... but I don't have time."
            </p>
            <p data-id="element-275">You've been ignoring it for weeks. Months. Maybe over a year.</p>
          </div>

          <p data-id="element-276">
            Meanwhile, your neighbor across the street has an impeccable lawn.
            Bright green. Perfect lines. Like a golf course.
          </p>

          <p className="font-semibold" data-id="element-277">
            Do you know the difference between your home and theirs?
          </p>

          <p className="text-3xl font-bold text-[#2D5A27] text-center py-8" data-id="element-278">
            One phone call.
          </p>
        </motion.div>
      </div>
    </section>;
}